import { Directive, InjectionToken, TemplateRef } from '@angular/core';

export const SELECT_FOOTER_CONTENT =
  new InjectionToken<SelectFooterContentDirective>('SelectFooterContent');

@Directive({
  selector: '[appSelectFooter]',
  providers: [
    {
      provide: SELECT_FOOTER_CONTENT,
      useExisting: SelectFooterContentDirective,
    },
  ],
  standalone: false,
})
export class SelectFooterContentDirective {
  constructor(public template: TemplateRef<any>) {}
}
